import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  FavoritesProductsListGetRequestQuery,
  ListingOptionsOfFavoriteProductsFilterOptions,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'

@injectable()
export class FavoritesService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  /**
   * Получить список избранных товаров (GET)
   */
  list(query: FavoritesProductsListGetRequestQuery) {
    return this.api.favoritesProductsListGet(this.appConfig.host, query)
  }

  /**
   * Получить список избранных товаров с фильтрацией (POST)
   */
  listFiltered(model: ListingOptionsOfFavoriteProductsFilterOptions) {
    return this.api.favoritesProductsListPost(this.appConfig.host, model)
  }

  /**
   * Добавить товар в избранное
   */
  add(productId: number) {
    return this.api.favoritesProductsAdd(productId, this.appConfig.host)
  }

  /**
   * Удалить товар из избранного
   */
  remove(productId: number) {
    return this.api.favoritesProductsRemove(productId, this.appConfig.host)
  }
}
